import { faChevronDown } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { faHeart } from "@fortawesome/pro-solid-svg-icons/faHeart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLoaderData } from "react-router";

import NextDayImage from "../assets/images/luxury-image.jpg";
import OccasionsImage from "../assets/images/occasion-image.jpg";
import PlantImage from "../assets/images/plant-image.webp";
import { useAppContext } from "../contexts/AppContext";
import { useAppStore } from "../stores/AppStore";

import "../assets/scss/components/_navigation-links.scss";
import type { NavigationLinksProps } from "../types/components/NavigationLinksProps";
import { Image } from "./Image";

export const NavigationLinks = ({ closeNav }: NavigationLinksProps) => {
	const loaderData = useLoaderData();
	const appData = useAppContext();
	const navigationLinks = loaderData?.navigationLinks;

	const { peakConfigs: storedPeakConfigs } = useAppStore(({ peakConfigs }) => ({ peakConfigs }));
	const peakConfigs = appData?.peakConfigs || storedPeakConfigs;

	const extraInfo = {
		"next-day-flowers": {
			image: NextDayImage,
			description:
				"Next day flowers delivered with care. Our bouquets are hand-tied and delivered in luxury packaging. We offer next day delivery nationwide.",
		},
		plants: {
			image: PlantImage,
			description:
				"Plants are a great gift for any occasion. We offer a wide range of plants for delivery nationwide. Order online today!",
		},
		"birthday-flowers": {
			image: OccasionsImage,
			title: "Occasions",
			description:
				"We offer a wide range of flowers for all occasions. From birthdays to anniversaries, we have the perfect bouquet for you.",
		},
	};

	const SubMenu = (link) => {
		return (
			link.links && (
				<div className="sub-menu">
					<div className="row">
						<div className="col-12 col-md-6">
							{link.links.map((subLink, index) => {
								return (
									<Link
										key={index}
										to={subLink.slug}
										className={subLink.classes ? subLink.classes : ""}
										aria-label={subLink.name}
										title={subLink.name}
										onClick={closeNav}
										prefetch="intent"
									>
										{subLink.name}
									</Link>
								);
							})}
						</div>
						{extraInfo[link.slug] && (
							<div className="col-6 img-container desktop-only">
								{extraInfo[link.slug]["image"] && (
									<Image
										src={extraInfo[link.slug]["image"]}
										alt={extraInfo[link.slug]["title"] ?? link.name}
										width="100"
									/>
								)}

								<strong>{extraInfo[link.slug]["title"] ?? link.name}</strong>
								{extraInfo[link.slug] && extraInfo[link.slug]["description"] && (
									<p>{extraInfo[link.slug]["description"]}</p>
								)}
							</div>
						)}
					</div>
				</div>
			)
		);
	};

	return (
		<>
			{navigationLinks &&
				navigationLinks.map((link, index) => {
					return (
						<div
							key={index}
							className={`parent-link ${link.classes ? link.classes : ""} ${link.name.toLowerCase().replaceAll(" ", "-")}`}
							onClick={(e) => {
								e.target.classList.toggle("open");
							}}
						>
							<Link to={link.slug} aria-label={link.name} title={link.name} onClick={closeNav}>
								{link.name}

								{peakConfigs?.MOTHERS_DAY && link?.name?.startsWith("Mother") && 1 == 2 && (
									<FontAwesomeIcon className="mothers-day-heart" icon={faHeart} />
								)}
							</Link>
							<span className="open-indicator">
								{link.links && <FontAwesomeIcon icon={faChevronDown} />}
							</span>
							{SubMenu(link)}
						</div>
					);
				})}
		</>
	);
};
